/* eslint-disable object-shorthand */
import Vue from 'vue';
import Vuex from 'vuex';
// import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    searchResults: [],
  },
  mutations: {
    updateSearchResults(state, searchResults) {
      state.searchResults.push(searchResults);
    },
    resetSearchResults(state) {
      state.searchResults = [];
    },
  },
  // actions: {
  //   getBooks({ commit }, { title, image }) {
  //     axios.post('/api', {
  //       text: title,
  //       image: image,
  //     }).then((response) => {
  //       debugger;
  //       // eslint-disable-next-line no-restricted-syntax
  //       for (const book of Object.values(response.data)) {
  //         commit('updateSearchResults', book);
  //       }
  //       // response.data.forEach((book) => {
  //       //   commit('updateSearchResults', book);
  //       //   console.log(book);
  //       // });
  //       // commit('updateSearchResults', JSON.stringify(response.data));
  //     }).catch((error) => {
  //       console.log(error);
  //     });
  //   },
  // },
  modules: {
  },
});
